// extracted by mini-css-extract-plugin
export default {"table":"index_table_o99vq","thead_wrapper":"index_thead_wrapper_Lveax","tbody_wrapper":"index_tbody_wrapper_zLymi","nomore":"index_nomore_yYvw0"};